import React, { useEffect, useState, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { NavLink, useNavigate } from 'react-router-dom';

import { Config } from '../../common/config';
import AlertModal from '../../components/alertModal';
import LeftMenu from '../../components/leftMenu';
import {
  formatStrNumber,
  getFormattedDateTime,
  delComString,
  getErrorMessage,
  isSuccessResponse,
} from '../../components/utils';
import translations from '../../data/translation';
import LocaleDateInput from '../../components/LocaleDateInput';
import useAxiosFetch from '../../hooks/useAxiosFetch';
import useStoreNo from '../../hooks/useStoreNo';
import { prepareGiftImage } from '../../utils/resizeGiftImage';

export default function GiftContent(_props) {
  const navigate = useNavigate();
  const language = useSelector(state => state.language.language); // redux에서 언어 상태 가져오기
  const t = translations[language]; // 현재 언어에 따른 번역 객체 가져오기
  const storeNo = useStoreNo();

  const [modalOpen, setModalOpen] = useState(false); //모달 상태 관리 : 기본값 - 닫힘
  const [modalInfo, setModalInfo] = useState({
    isCancel: false,
    isConfirm: true,
    isMessage: true,
    headerMsg: '',
    actionFlag: '',
    mainMsg: '',
    action: '',
    isPercent: false,
    img: null,
  });
  const [giftName, setgiftName] = useState('');
  const [categoryCode, setCategoryCode] = useState('');
  const [categoryData, setCategoryData] = useState([]);
  const [imageFile, setImageFile] = useState(null);
  const [imageFileName, setImageFileName] = useState(null);
  const [giftDesc, setGiftDesc] = useState('');
  const [openAIGiftDescData, setOpenAIGiftDescData] = useState([]);
  const [openAISelectedData, setOpenAISelectedcData] = useState('');
  const [hasAdCopySelection, setHasAdCopySelection] = useState(false);
  const [price, setPrice] = useState('');
  const [lastValidPrice, setLastValidPrice] = useState('');
  const [basePrice, setBasePrice] = useState('');
  // 할인금액(정상가격에서 빼는 금액). 바우처와 무관한 상점 자체 할인 — 서버에는 할인 적용 후 가격(discountPrice)으로 보낸다.
  const [discountPrice, setDiscountPrice] = useState('');
  const today = getFormattedDateTime(new Date());
  const [saleStartDttm, setSaleStartDttm] = useState(today.slice(0, 10));
  const [saleEndDttm, setSaleEndDttm] = useState('');
  const [saleEndDttmPre, setSaleEndDttmPre] = useState('');
  // 유효기간은 약관에 따라 3개월로 고정
  const [validityMonth, setValidityMonth] = useState('3');
  const [_validityDay, _setValidityDay] = useState('');
  const [_validityMonthPre, setValidityMonthPre] = useState('3');
  const [_validityDayPre, _setValidityDayPre] = useState('');
  const [countIssue, setCountIssue] = useState('');
  const [countIssuePre, setCountIssuePre] = useState('');
  const [isSalePeriodChecked, setIsSalePeriodChecked] = useState(false);
  const [_isValidityChecked, setIsValidityChecked] = useState(true);
  const [isCountIssueChecked, setIsCountIssueChecked] = useState(false);


  const { fetchData } = useAxiosFetch();

  // Inline validation error messages
  const [priceError, setPriceError] = useState('');
  const [basePriceError, setBasePriceError] = useState('');
  const [discountPriceError, setDiscountPriceError] = useState('');
  const [_validityError, _setValidityError] = useState('');
  const [countIssueError, setCountIssueError] = useState('');
  const [imageError, setImageError] = useState('');
  const basePriceNum = Number(delComString(basePrice) || '0');
  const discountPriceNum = Number(delComString(discountPrice) || '0');
  const effectivePrice = discountPriceNum > 0 ? basePriceNum - discountPriceNum : basePriceNum;
  const isStampDutyTarget = effectivePrice >= 50000;

  const openModal = () => {
    if (modalInfo.actionFlag === 'api' && !modalInfo.mainMsg) {
      setModalInfo(prev => ({
        ...prev,
        mainMsg: t.requestError,
      }));
    }
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalInfo(prev => ({
      ...prev,
      actionFlag: '',
      isCancel: false,
      isConfirm: true,
      img: null,
    }));
    setModalOpen(false);
  };

  const doModal = () => {
    setModalOpen(false);
    if (modalInfo.actionFlag === 'goMain') {
      navigate('/go-main');
    } else if (modalInfo.actionFlag === 'openai') {
      setModalInfo(prev => ({ ...prev, actionFlag: '' }));
      setGiftDesc(openAISelectedData ? openAISelectedData : giftDesc);
      setHasAdCopySelection(true);
    } else if (modalInfo.actionFlag === 'regToday') {
      // 오늘 바로 판매시작 확인 → 등록 진행 (취소는 closeModal 로 아무것도 안 함)
      setModalInfo(prev => ({ ...prev, actionFlag: '', isCancel: false }));
      regGift();
    }
  };

  const categoryChange = e => {
    setCategoryCode(e.target.value);
    setOpenAIGiftDescData([]);
    setOpenAISelectedcData('');
    setHasAdCopySelection(false);
  };

  const giftDescChange = e => {
    const selected = e.target.value;
    setOpenAISelectedcData(selected);
    setGiftDesc(selected);
    setHasAdCopySelection(true);
  };

  const salePeriodCheckboxChange = e => {
    setIsSalePeriodChecked(!isSalePeriodChecked);

    if (e.target.checked) {
      setSaleEndDttm('');
    } else {
      setSaleEndDttm(saleEndDttmPre);
    }
  };

  // 유효기간은 3개월로 고정되므로 기존 체크박스 핸들러는 사용하지 않음

  const countIssueCheckboxChange = e => {
    setIsCountIssueChecked(!isCountIssueChecked);

    if (e.target.checked) {
      setCountIssue('');
    } else {
      setCountIssue(countIssuePre);
    }
  };

  // JWT refresh is handled centrally in useAxiosFetch

  const getData = useCallback(async _unused => {
    try {
      const ret = await fetchData({
        url: `${Config.API_ADMIN_CODE_DETAIL}?pageSize=20&sortOrd=asc&groupCode=NG02`,
        method: 'get',
      });
      if (ret?.data?.data) {
        const list = ret.data.data.list || [];
        setCategoryData(list);
        const preferredFive = list.find(
          c => c.detailCode && String(c.detailCode).length === 5
        );
        const first = list[0];
        const next = preferredFive?.detailCode ?? first?.detailCode ?? '';
        if (next) {
          setCategoryCode(next);
        }
      }
    } catch (error) {
      console.error('Error getData:', error);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const changeFile = async e => {
    const input = e.target;
    const picked = input.files[0];
    if (picked) {
      // 큰 사진은 긴 변 1,500px로 자동 축소 — 줄여도 3MB를 넘을 때(큰 GIF 등)만 안내
      const file = await prepareGiftImage(picked);
      if (!file) {
        input.value = null; // 파일 선택 취소
        setImageFile(null);
        setImageFileName(null);
        setImageError(t.imageSizeError);
      } else {
        setImageError('');
        const imageUrl = URL.createObjectURL(file);
        setImageFile(imageUrl);
        setImageFileName(file);
      }
    } else {
      setImageFile(null);
      setImageFileName(null);
      setImageError('');
    }
  };

  const changeDesc = async () => {
    try {
      if (!giftName) {
        setModalInfo(prev => ({
          ...prev,
          mainMsg: t.giftNameRequired,
        }));
        setModalOpen(true);
        return;
      }

      setModalInfo(prev => ({
        ...prev,
        actionFlag: 'adCopyLoading',
        mainMsg: '',
        isCancel: false,
        isConfirm: false,
        img: null,
      }));
      openModal();

      const ret = await fetchData({
        url: `${Config.API_SERVER}gift/ad-copies/preview`,
        method: 'post',
        data: {
          giftName,
          categoryCode,
        },
      });

      if (!isSuccessResponse(ret)) {
        setModalInfo(prev => ({
          ...prev,
          actionFlag: 'api',
          mainMsg: getErrorMessage(ret),
          isCancel: false,
          isConfirm: true,
          img: null,
        }));
        setModalOpen(true);
        return;
      }

      const copies = (ret?.data?.data?.copies || []).slice(0, 5);
      if (copies.length === 0) {
        setModalInfo(prev => ({
          ...prev,
          actionFlag: 'api',
          mainMsg: '광고문구 생성 결과가 비어 있습니다.',
          isCancel: false,
          isConfirm: true,
          img: null,
        }));
        setModalOpen(true);
        return;
      }

      setOpenAIGiftDescData(copies);
      setOpenAISelectedcData(copies[0]);
      setHasAdCopySelection(false);
      setModalInfo(prev => ({
        ...prev,
        actionFlag: 'openai',
        isCancel: true,
        isConfirm: true,
        img: null,
      }));
      setModalOpen(true);
    } catch (error) {
      setModalInfo(prev => ({
        ...prev,
        actionFlag: 'api',
        mainMsg: getErrorMessage(error?.response),
        isCancel: false,
        isConfirm: true,
        img: null,
      }));
      setModalOpen(true);
      console.error('Error fetching data:', error);
    }
  };

  const checkRegGift = () => {
    if (!giftName) {
      setModalInfo(prev => ({ ...prev, mainMsg: '기프트명을 입력해 주세요.' }));
      return false;
    }
    if (giftName.length > 50) {
      setModalInfo(prev => ({
        ...prev,
        mainMsg: t.giftNameMaxLength,
      }));
      return false;
    }
    if (!giftDesc || giftDesc.trim() === '') {
      setModalInfo(prev => ({ ...prev, mainMsg: t.giftAdRequired }));
      setModalOpen(true);
      return false;
    }
    if (giftDesc && giftDesc.length > 100) {
      setModalInfo(prev => ({
        ...prev,
        mainMsg: t.giftAdMaxLength,
      }));
      return false;
    }
    if (!imageFileName) {
      setModalInfo(prev => ({
        ...prev,
        mainMsg: t.giftPhotoRequired,
      }));
      setModalOpen(true);
      return false;
    }
    const bpNum = Number(delComString(basePrice) || '0');
    if (basePrice === '' || basePrice == null || Number.isNaN(bpNum)) {
      setModalInfo(prev => ({ ...prev, mainMsg: '정상가격을 입력해 주세요.' }));
      return false;
    }
    if (bpNum >= 1000000) {
      setModalInfo(prev => ({ ...prev, mainMsg: t.giftPriceMin }));
      return false;
    }
    if (bpNum !== 0 && bpNum % 100 !== 0) {
      setModalInfo(prev => ({ ...prev, mainMsg: t.giftPriceUnit }));
      return false;
    }
    const dpNum = Number(delComString(discountPrice) || '0');
    if (dpNum % 100 !== 0) {
      setModalInfo(prev => ({ ...prev, mainMsg: t.giftPriceUnit }));
      return false;
    }
    if (dpNum > 0 && dpNum >= bpNum) {
      setModalInfo(prev => ({ ...prev, mainMsg: '할인가격은 정상가격보다 작아야 합니다.' }));
      return false;
    }
    // 유효기간은 항상 3개월로 고정
    if (validityMonth !== '3') {
      setValidityMonth('3');
      setValidityMonthPre('3');
      setIsValidityChecked(true);
    }
    // 판매종료일은 날짜를 고르거나 무기한을 체크해야 한다 (비워두면 무기한으로 저장되던 것 방지)
    if (!isSalePeriodChecked && !saleEndDttm) {
      setModalInfo(prev => ({ ...prev, mainMsg: t.saleEndRequired }));
      return false;
    }
    // 총발행수량은 직접 입력하거나 무제한을 체크해야 한다 (비워두면 무제한으로 저장되던 것 방지)
    const countNum = Number(delComString(countIssue) || '0');
    if (!isCountIssueChecked && !(countNum > 0)) {
      setModalInfo(prev => ({ ...prev, mainMsg: t.countIssueRequired }));
      return false;
    }
    return true;
  };

  // 등록 버튼: 시작일이 오늘이면 등록 즉시 판매가 시작된다는 걸 알리고 한 번 더 묻는다
  const onClickReg = () => {
    if (checkRegGift() !== true) {
      setModalInfo(prev => ({ ...prev }));
      setModalOpen(true);
      return;
    }
    if (saleStartDttm === today.slice(0, 10)) {
      setModalInfo(prev => ({
        ...prev,
        actionFlag: 'regToday',
        isCancel: true,
        mainMsg: t.confirmRegisterToday,
      }));
      setModalOpen(true);
      return;
    }
    regGift();
  };

  const regGift = async () => {
    try {
      if (checkRegGift() === true) {
        const formData = new FormData();
        formData.append('giftName', giftName);
        formData.append('categoryCode', categoryCode);
        if (giftDesc !== '') {
          formData.append('giftDesc', giftDesc);
        }
        const bpVal = Number(delComString(basePrice) || '0');
        const dpVal = Number(delComString(discountPrice) || '0');
        formData.append('basePrice', bpVal);
        if (dpVal > 0) formData.append('discountPrice', bpVal - dpVal);
        formData.append('saleStartDttm', saleStartDttm);
        if (saleEndDttm !== '') {
          formData.append('saleEndDttm', saleEndDttm);
        }
        // 바우처 실증기간(~2026-09-30) 종료 — 바우처 미적용(N) + 유효기간 3개월 고정으로만 등록한다.
        formData.append('validity', '3M');
        if (!isCountIssueChecked) {
          formData.append('countIssued', Number(delComString(countIssue)));
        }
        formData.append('transferTime', '1M');
        formData.append('voucherUseYn', 'N');
        if (saleStartDttm === today.slice(0, 10)) {
          formData.append('state', 'SS002');
        }
        if (imageFile) {
          formData.append('file', imageFileName);
        }
        const ret = await fetchData({
          url: `${Config.API_SERVER}gift`,
          method: 'post',
          data: formData,
          // auth handled by fetchData/axios config (cookies/session)
        });
        if (!ret) {
          return;
        }
        if (isSuccessResponse(ret)) {
          const createdGiftNo = ret?.data?.data?.giftNo;
          if (
            createdGiftNo &&
            hasAdCopySelection &&
            Array.isArray(openAIGiftDescData) &&
            openAIGiftDescData.length > 0
          ) {
            try {
              await fetchData({
                url: `${Config.API_SERVER}gift/${createdGiftNo}/ad-copies`,
                method: 'put',
                data: { copies: openAIGiftDescData.slice(0, 5) },
              });
            } catch (_e) {
              // 광고문구 저장 실패가 기프트 등록 성공을 막지 않도록 무시
            }
          }
          navigate(`/${storeNo}/gift-list`);
        } else {
          setModalInfo(prev => ({
            ...prev,
            actionFlag: 'api',
            mainMsg: getErrorMessage(ret),
          }));
          setModalOpen(true);
        }
      } else {
        setModalInfo(prev => ({ ...prev }));
        setModalOpen(true);
      }
    } catch (error) {
      setModalInfo(prev => ({
        ...prev,
        actionFlag: 'api',
        mainMsg: getErrorMessage(error?.response),
      }));
      setModalOpen(true);
      console.error('Error fetching data:', error);
    }
  };

  useEffect(() => {
    getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <AlertModal
        open={modalOpen}
        close={closeModal}
        action={doModal}
        header={modalInfo.headerMsg}
        isConfirm={modalInfo.isConfirm}
        isMessage={modalInfo.isMessage}
        isCancel={modalInfo.isCancel}
        img={modalInfo.img}
      >
        {modalInfo.actionFlag === 'adCopyLoading' ? (
          <div className="ad-copy-generating">
            <div className="ad-copy-generating__visual" aria-hidden="true">
              <div className="ad-copy-generating__glow" />
              <div className="ad-copy-generating__ring ad-copy-generating__ring--a" />
              <div className="ad-copy-generating__ring ad-copy-generating__ring--b" />
              <div className="ad-copy-generating__core">
                <span className="ad-copy-generating__spark" />
              </div>
            </div>
            <div className="ad-copy-generating__title">광고 문구 생성 중</div>
            <div className="ad-copy-generating__sub">
              생성형 AI가 매장·상품 정보를 바탕으로 후보 5개를 만들고 있어요.
            </div>
            <div className="ad-copy-generating__dots" aria-hidden="true">
              <span />
              <span />
              <span />
            </div>
          </div>
        ) : modalInfo.actionFlag === 'openai' ? (
          <div className="ad-copy-modal">
            <div className="ad-copy-modal__title">{t.giftAdSelect}</div>
            <div className="ad-copy-modal__desc">
              생성된 문구 중 하나를 선택하면 입력창에 바로 반영됩니다.
            </div>
            <div className="ad-copy-modal__list">
              {openAIGiftDescData.map((item, index) => {
                const id = `ad-copy-create-${index}`;
                const checked = (openAISelectedData || '') === item;
                return (
                  <label
                    key={id}
                    className={`ad-copy-option${checked ? ' is-selected' : ''}`}
                    htmlFor={id}
                  >
                    <input
                      id={id}
                      type="radio"
                      name="ad-copy-create"
                      value={item}
                      checked={checked}
                      onChange={giftDescChange}
                    />
                    <span className="ad-copy-option__index">{index + 1}</span>
                    <span className="ad-copy-option__text">{item}</span>
                  </label>
                );
              })}
            </div>
          </div>
        ) : (
          <>{modalInfo.mainMsg}</>
        )}
      </AlertModal>

      <section className="location_box location_box_mypage">
        <ul className="location_001">
          <li>{t.home}</li>
          <li>
            <NavLink
              to={storeNo ? `/${storeNo}/gift-list` : '/gift-list'}
              title={t.giftManagement}
            >
              {t.giftManagement}
            </NavLink>
          </li>
          <li>
            <NavLink
              to={storeNo ? `/${storeNo}/gift-content` : '/gift-content'}
              title={t.registerGift}
            >
              {t.registerGift}
            </NavLink>
          </li>
        </ul>
      </section>

      <main>
        <section className="contants_box contants_box_mypage">
          <LeftMenu pageName="gift" />

          <section className="rightcontant_box">
            <h2 className="tit_01">{t.registerGift}</h2>

            <article className="form_card contants_box_03">
              <table className="member_box">
                <tbody>
                  <tr>
                    <th>{t.giftName}</th>
                    <td>
                      <form>
                        <input
                          className="input_03"
                          type="text"
                          placeholder=""
                          maxLength={50}
                          onChange={e => {
                            setgiftName(e.target.value);
                            setOpenAIGiftDescData([]);
                            setOpenAISelectedcData('');
                            setHasAdCopySelection(false);
                          }}
                          value={giftName}
                        />
                      </form>
                      {giftName && giftName.length >= 50 && (
                        <div className="font_red">{t.giftNameMaxChars}</div>
                      )}
                    </td>
                  </tr>
                  <tr>
                    <th>{t.category}</th>
                    <td>
                      <form>
                        <select
                          className="input_01 select_01 gift-category-select"
                          onChange={categoryChange}
                          value={categoryCode}
                        >
                          {categoryData.map((category, index) => (
                            <option key={index} value={category.detailCode}>
                              {t.selectCategory[category.detailCodeName] ||
                                category.detailCodeName}
                            </option>
                          ))}
                        </select>
                      </form>
                      <div className="gift-category-hint">
                        목록에서 카테고리를 선택해 주세요.
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th>{t.giftPhoto}</th>
                    <td>
                      <div className="gift-photo-upload">
                        <div className="gift-photo-upload__preview">
                          {imageFile && <img src={imageFile} alt="Selected" />}
                        </div>
                        <div className="gift-photo-upload__actions">
                          <label className="gift-photo-upload__btn">
                            <input
                              type="file"
                              name="fileInput"
                              onChange={changeFile}
                              accept=".jpg, .jpeg, .gif, .png"
                            />
                            {t.selectImage}
                          </label>
                          <p className="gift-photo-upload__note font_gray">
                            {t.giftUploadFileNote}
                          </p>
                          {imageError && (
                            <div className="font_red">{imageError}</div>
                          )}
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th>{t.giftAd}</th>
                    <td>
                      <form>
                        <input
                          className="input_04"
                          type="text"
                          placeholder=""
                          maxLength={100}
                          onChange={e => {
                            setGiftDesc(e.target.value);
                          }}
                          value={giftDesc}
                        />
                      </form>
                      {giftDesc && giftDesc.length >= 100 && (
                        <div className="font_red">{t.giftAdMaxChars}</div>
                      )}
                      {openAIGiftDescData.length > 0 && (
                        <div style={{ marginTop: '8px' }}>
                          <select
                            className="input_01 select_01 gift-category-select"
                            onChange={giftDescChange}
                            value={openAISelectedData || ''}
                          >
                            {openAIGiftDescData.map((item, index) => (
                              <option key={index} value={item}>
                                {item}
                              </option>
                            ))}
                          </select>
                        </div>
                      )}
                    </td>
                  </tr>
                  <tr>
                    <th>정상가격</th>
                    <td>
                      <form>
                        <input
                          className="input_01_01"
                          style={{ textAlign: 'right' }}
                          type="text"
                          maxLength={11}
                          value={basePrice}
                          onChange={e => {
                            const noComma = e.target.value.replace(/,/g, '');
                            if (/^\d*$/.test(noComma)) {
                              const numeric = Number(noComma || '0');
                              if (numeric >= 1000000) {
                                setBasePriceError(t.giftPriceUnitManage);
                                return;
                              } else if (numeric !== 0 && numeric % 100 !== 0) {
                                setBasePriceError(t.giftPriceUnit);
                              } else {
                                setBasePriceError('');
                              }
                              setBasePrice(formatStrNumber(noComma));
                            } else {
                              setBasePriceError(t.numbersOnly);
                            }
                          }}
                        />
                        &ensp;&ensp;&ensp;{t.currency}
                      </form>
                      {basePriceError && <div className="font_red">{basePriceError}</div>}
                    </td>
                  </tr>
                  <tr>
                    <th>할인가격</th>
                    <td>
                      <form>
                        <input
                          className="input_01_01"
                          style={{ textAlign: 'right' }}
                          type="text"
                          maxLength={11}
                          placeholder="없으면 비워두세요"
                          value={discountPrice}
                          onChange={e => {
                            const noComma = e.target.value.replace(/,/g, '');
                            if (/^\d*$/.test(noComma)) {
                              const numeric = Number(noComma || '0');
                              setDiscountPriceError(numeric % 100 !== 0 ? t.giftPriceUnit : '');
                              setDiscountPrice(noComma ? formatStrNumber(noComma) : '');
                            } else {
                              setDiscountPriceError(t.numbersOnly);
                            }
                          }}
                        />
                        &ensp;&ensp;&ensp;{t.currency}
                      </form>
                      {discountPriceError && <div className="font_red">{discountPriceError}</div>}
                      {discountPriceNum > 0 && basePriceNum > 0 && (
                        <div style={{ marginTop: '6px', fontSize: '12px', color: '#888' }}>
                          정상가격 {formatStrNumber(String(basePriceNum))}원 − {formatStrNumber(String(discountPriceNum))}원 = <strong style={{ color: '#e53e3e' }}>{formatStrNumber(String(effectivePrice))}원</strong>
                        </div>
                      )}
                    </td>
                  </tr>
                  <tr>
                    <th>
                      판매가
                      <div style={{ fontSize: '11px', fontWeight: 'normal', color: '#aaa', marginTop: '2px' }}>최종 결제금액</div>
                    </th>
                    <td>
                      <input
                        className="input_01_01"
                        type="text"
                        disabled
                        style={{ backgroundColor: '#f0f4ff', textAlign: 'right', fontWeight: 'bold', color: '#1a56db', border: '1px solid #c3d3f7' }}
                        value={effectivePrice > 0 ? formatStrNumber(String(effectivePrice)) : ''}
                      />
                      &ensp;&ensp;&ensp;{t.currency}
                      {isStampDutyTarget && (
                        <div className="gift-price-notice">
                          {t.giftStampDutyNotice}
                        </div>
                      )}
                    </td>
                  </tr>
                  <tr>
                    <th>{t.salePeriod}</th>
                    <td>
                      <form>
                        <LocaleDateInput
                          className="input_05"
                          minDate={today.slice(0, 10)}
                          value={saleStartDttm}
                          onChange={val => {
                            setSaleStartDttm(val);
                            if (saleEndDttm && saleEndDttm < val) {
                              setSaleEndDttm(val);
                              setSaleEndDttmPre(val);
                            }
                          }}
                        />{' '}
                        ~{' '}
                        <LocaleDateInput
                          className="input_05"
                          minDate={saleStartDttm}
                          disabled={isSalePeriodChecked}
                          style={{
                            backgroundColor: isSalePeriodChecked
                              ? '#ddd'
                              : undefined,
                          }}
                          value={saleEndDttm}
                          onChange={val => {
                            setSaleEndDttm(val);
                            setSaleEndDttmPre(val);
                          }}
                        />
                        <label className="check_box">
                          {t.giftUnlimited}
                          <input
                            type="checkbox"
                            checked={isSalePeriodChecked}
                            onChange={salePeriodCheckboxChange}
                          />
                          <span className="check_check"></span>
                        </label>
                      </form>
                      <div className="font_red">{t.datePickerOnly}</div>
                    </td>
                  </tr>
                  <tr>
                    <th>{t.validityPeriod}</th>
                    <td>
                      {t.purchaseAfter}&ensp;&ensp;&ensp;&ensp;&ensp;
                      <input
                        className="input_02"
                        type="text"
                        style={{
                          textAlign: 'right',
                          backgroundColor: '#ddd',
                        }}
                        maxLength={2}
                        disabled
                        readOnly
                        value="3"
                      />{' '}
                      {t.month}
                      <span
                        style={{
                          marginLeft: '10px',
                          color: '#666',
                          fontSize: '12px',
                        }}
                      >
                        {t.validityFixed}
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <th>{t.totalIssuedQuantity}</th>
                    <td>
                      <form>
                        <input
                          className="input_05"
                          type="text"
                          style={{
                            textAlign: 'right',
                            backgroundColor: isCountIssueChecked
                              ? '#ddd'
                              : undefined,
                          }}
                          maxLength={11}
                          disabled={isCountIssueChecked}
                          onChange={e => {
                            const raw = e.target.value.replace(/,/g, '');
                            if (/^\d*$/.test(raw)) {
                              setCountIssueError('');
                            } else {
                              setCountIssueError(t.numbersOnly);
                            }
                            setCountIssue(formatStrNumber(raw));
                            setCountIssuePre(formatStrNumber(raw));
                          }}
                          value={countIssue}
                        />{' '}
                        {t.quantity}
                        <label className="check_box">
                          &ensp;&ensp;&ensp;{t.unlimited}
                          <input
                            type="checkbox"
                            checked={isCountIssueChecked}
                            onChange={countIssueCheckboxChange}
                          />
                          <span className="check_check"></span>
                        </label>
                      </form>
                      {countIssueError && (
                        <div className="font_red">{countIssueError}</div>
                      )}
                    </td>
                  </tr>
                  <tr>
                    <th>{t.registrationDateTime}</th>
                    <td>
                      <form>
                        <input
                          className="input_01"
                          type="text"
                          disabled
                          style={{
                            backgroundColor: '#ddd',
                            textAlign: 'center',
                          }}
                          value={today}
                        />
                      </form>
                    </td>
                  </tr>
                </tbody>
              </table>
            </article>

            <article className="button_box_01">
              <NavLink to={`/${storeNo}/gift-list`}>
                <button
                  type="button"
                  className="button_01 button_03 button_gray_line"
                >
                  {t.cancel}
                </button>
              </NavLink>
              <button
                type="button"
                className="button_01 button_03 button_red"
                onClick={onClickReg}
              >
                {t.register}
              </button>
            </article>
          </section>
        </section>
      </main>
    </>
  );
}
